module.exports = __webpack_public_path__ + "static/media/tinyBuilding.81ae024a.svg";